define('shared/initializer/form/adapters/mixins/LoginErrorVisible',[
    'shared/lib/URI',
    'shared/lib/RSVP'
], function(
    URI,
    RSVP
){
    function Ctor() { }

    Ctor.prototype.doPageLoad = function () {
        var me = this;
        var uri = new URI(window.location.href);

        if(uri.query(true).auth === 'false'){
            var err = new Error('login attempt failed.');
            err.type = 'generic';
            err.fatal = false;
            me.emit('error', err);
        }

        return RSVP.resolve();
    };

    return Ctor;
});
